import { Image, Text, Thumbnail } from '@wix/design-system';
import { productsByCategory } from 'config/products';
import React, { FC, useMemo } from 'react';
import { useAppStore } from 'stores/appStore';
import styles from '../SelectProductsStep.scss';
import { useIsMobile } from 'hooks/useIsMobile';

const MAX_SELECTED_PRODUCTS = 4;

export const SelectProductsStepOptions: FC = () => {
  const isMobile = useIsMobile();

  const selectedCategory = useAppStore((state) => state.selectedCategory);
  const selectedProducts = useAppStore((state) => state.selectedProducts);
  const setSelectedProducts = useAppStore((state) => state.setSelectedProducts);

  const handleToggleProduct = (productId: string) => {
    if (selectedProducts.includes(productId)) {
      setSelectedProducts(selectedProducts.filter((p) => p !== productId));
    } else {
      setSelectedProducts([...selectedProducts, productId]);
    }
  };

  return (
    <div className={styles.selectProductsStepOptions}>
      {productsByCategory[selectedCategory].map((product) => {
        const isSelected = selectedProducts.includes(product.id);
        const image = isSelected && isMobile ? product.mockupImageUrl : product.imageUrl;
        return (
          <div key={product.id} className={styles.selectProductsStepOptionsItem}>
            <Thumbnail
              disabled={selectedProducts.length >= MAX_SELECTED_PRODUCTS && !isSelected}
              onClick={() => handleToggleProduct(product.id)}
              selected={isSelected}
            >
              <Image transparent src={image} alt={product.name} />
            </Thumbnail>
            <div className={styles.selectProductsStepOptionsItemLabel}>
              <Text ellipsis size="small" weight="normal" maxLines={3}>
                {product.name}
              </Text>
            </div>
          </div>
        );
      })}
    </div>
  );
};
